import { atom } from "recoil";

/**
 * Atom that contains the lbf state of the app
 * It is used to store the lbf from Next Router to Recoil
 * Used in combination with useLBF to have it automatically setted
 * @author JBO
 */
export const lbfState = atom({ key: "LbfState", default: "" });
